import { useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { Panes } from 'modules/core/components/Panes'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import ApprovalsBlock from 'modules/approvals/components/ApprovalsConfigurationBlock'
import { AddPolicyModal } from 'modules/attendance/components/TimeTrackingSettings/AddPolicyModal'
import { useDeprecatedTimeTrackingFeatureAvailability } from 'modules/attendance/lib/useTimeTrackingFeatureAvailability'
import Page from 'modules/layout/components/Page'
import Header from 'modules/layout/components/Page/Header'
import RequestUpgradeModal from 'modules/upsell/components/RequestUpgradeModal'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

import OvernightShifts from './Content/OvernightShifts'
import TimeTrackingPolicy from './Content/TimeTrackingPolicy'

const TimeTrackingSettings = () => {
  const [isAddModalOpen, toggleAddModal] = useToggle(false)
  const [isUpgradeModalOpen, toggleUpgradeModal] = useToggle(false)
  const { navigation } = useNavigation()
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const overtimeRequestsEnabled = useDeprecatedTimeTrackingFeatureAvailability(
    companyId,
    'time_tracking_overtime_requests'
  )
  const timeTrackingMultiPoliciesEnabled = useDeprecatedTimeTrackingFeatureAvailability(
    companyId,
    'time_tracking_multi_policies'
  )
  const editTimesheetAuthorizationEnabled = useDeprecatedTimeTrackingFeatureAvailability(
    companyId,
    'time_tracking_edit_timesheet_authorization'
  )

  useEffect(() => {
    track(trackingEvents.timeTracking.navigateToTimeTrackingSettingsPage)
  }, [])

  return (
    <Page>
      <Page.Header>
        <Header.Title
          action={{
            icon: 'add',
            label: i18n.t('time_tracking.settings.add_policy'),
            onClick: timeTrackingMultiPoliciesEnabled
              ? toggleAddModal(true)
              : toggleUpgradeModal(true),
          }}
          backTo={navigation.settings.fullPath()}
        >
          {i18n.t('company_settings.time.time_tracking.title')}
        </Header.Title>
      </Page.Header>
      <Page.Body size="narrow">
        <Panes direction="vertical">
          <TimeTrackingPolicy />
          {(overtimeRequestsEnabled || editTimesheetAuthorizationEnabled) && (
            <ApprovalsBlock
              category="time_tracking"
              title={i18n.t('time_tracking.settings.approvals.title')}
              description={i18n.t('time_tracking.settings.approvals.description')}
            />
          )}
          <OvernightShifts />
        </Panes>
      </Page.Body>
      {isUpgradeModalOpen && (
        <RequestUpgradeModal
          requestReason={ValidReasons.UpgradeFromLegacy}
          requestSource="app-store-time-tracking-settings"
          onClose={() => toggleUpgradeModal(false)}
        />
      )}
      {isAddModalOpen && <AddPolicyModal toggleAddModal={toggleAddModal} />}
    </Page>
  )
}

export default observer(TimeTrackingSettings)
